import Dexie from "dexie";
import http from "@/utils/Http";
const db = new Dexie("agrisoy");
db.version(1).stores({
    product_categories: 'id,name',
    products: 'id,name',
    payment_types: 'id,label',
    customer_groups: 'id,name,count',
    banks: 'id,name'
});

class ProductCategory {
    static async all() {
        return db.product_categories.orderBy('name').toArray()
    }

    static async putAll(product_categories = []) {
        return db.transaction('rw?', db.product_categories, async () => {
            db.product_categories.bulkPut(product_categories)
        });
    }
}

class Product {
    static async all() {
        return db.products.orderBy('name').toArray()
    }

    static async putAll(products = []) {
        return db.transaction('rw?', db.products, async () => {
            db.products.bulkPut(products)
        });
    }
}

class PaymentType {
    static async all() {
        return db.payment_types.orderBy('label').toArray()
    }

    static async putAll(payment_types = []) {
        return db.transaction('rw?', db.payment_types, async () => {
            db.payment_types.bulkPut(payment_types)
        });
    }
}

class CustomerGroup {
    static async all(order = 'name') {
        return new Promise((resolve, reject) => {
            db.customer_groups.orderBy(order).sortBy('count', array => {
                if (order === 'count')
                    array.sort((a, b) => a.count - b.count);
            })
            .then(result => {
                if (result && result.length > 0) resolve(result);
                http.get(`/v1/customers/load_customer_groups?order=${order}`)
                    .then(({data}) => {
                        CustomerGroup.putAll(data);
                        if (!result || result.length === 0) resolve(data);
                    })
                    .catch(reject);
            })
            .catch(reject)
        })
    }

    static async putAll(customer_groups = []) {
        return db.transaction('rw?', db.customer_groups, async () => {
            db.customer_groups.bulkPut(customer_groups)
        });
    }

    static async delete(key) {
        return db.customer_groups.delete(key)
    }
}

class Bank {
    static async all() {
        const banks = db.banks.orderBy('name').toArray() || [];

        return new Promise((resolve, reject) => {
            let preload = false;
            if (banks && banks.length > 0) {
                resolve(banks);
                preload = true;
            }

            http.get('/v1/banks')
                .then(({data}) => {
                    Bank.putAll(data);

                    if (!preload) resolve(data);
                })
                .catch(err => {
                    console.error(err);
                    reject(err);
                })
        });
    }

    static async putAll(banks = []) {
        return db.transaction('rw?', db.banks, async () => {
            db.banks.bulkPut(banks)
        });
    }
}

db.product_categories.mapToClass(ProductCategory);
db.products.mapToClass(Product);
db.payment_types.mapToClass(PaymentType);
db.customer_groups.mapToClass(CustomerGroup);
db.banks.mapToClass(Bank);

export {
    ProductCategory,
    Product,
    PaymentType,
    CustomerGroup,
    Bank
}
